import React, { useEffect, useState } from 'react';
import { apiRequest } from '../../api/index';

const CompanyCardModal = ({ isOpen, onClose }) => {
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (!isOpen) return; // Прерываем выполнение эффекта, если модальное окно закрыто


    const fetchCompanyData = async () => {
      try {
        const response = await apiRequest(`requisites/me?type=text`, 'GET');
        setCompanyData(response.data);
      } catch (error) {
        console.error('Ошибка при получении данных компании:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, [isOpen]);

  if (!isOpen) return null;

  const handleDownloadPDF = async () => {
    try {
      // Используем существующий метод apiRequest с флагом isFile
      const response = await apiRequest('requisites/me?type=file', 'GET', null, true);
      
      // Преобразуем ответ в Blob
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'requisites.pdf');
      document.body.appendChild(link);
      link.click();
      
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Ошибка при скачивании PDF:', error);
    }
  };

  const renderField = (label, value) => (
      <div className="company-card-field row" key={label}>
        <div className="col-6 text-muted">{label}</div>
        <div className="col-6">{value || '-'}</div>
      </div>
  );

  return (
      <div className={isMobile ? "modal-overlay-mobile" : "modal-overlay"} onClick={onClose}>
        <div className="modal fullscreen bottom-right open" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            {isMobile && (
              <button className="modal-close-btn" onClick={onClose} aria-label="Закрыть">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
            <h3>Карточка компании</h3>
          </div>
          <div className="modal-body">
            {loading ? (
                <p>Загрузка...</p>
            ) : companyData ? (
                <div className="container-fluid p-0">
                  {renderField('Наименование организации', companyData.name)}
                  {renderField('Юридический адрес', companyData.address)}
                  {renderField('ИНН организации', companyData.inn)}
                  {renderField('КПП организации', companyData.kpp)}
                  {renderField('ОГРН', companyData.ogrn)}
                  {renderField('Рассчетный счет', companyData.ras_invoice)}
                  {renderField('Наименование банка', companyData.name_bank)}
                  {renderField('Бик банка', companyData.bik_bank)}
                  {renderField('ИНН банка', companyData.inn_bank)}
                  {renderField('Корреспондентский счет', companyData.kor_invoice)}
                  {renderField('Юридический адрес банка', companyData.address_bank)}
                </div>
            ) : (
                <p>Не удалось загрузить данные.</p>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary-filled" onClick={handleDownloadPDF}>Скачать PDF</button>
          </div>
        </div>
      </div>
  );
};
export default CompanyCardModal;